import elektrokardiograf from "./images/devices/elektrokardiograf.jpg";
import hirurski_laser from "./images/devices/hirurski_laser.jpg";
import meki_laser from "./images/devices/meki_laser.jpg";
import otoakusticke_emisije from "./images/devices/otoakusticke_emisije.jpg";
import audiometar from "./images/devices/audiometar.jpg";
import timpanometar from "./images/devices/timpanometar.jpg";
import ultrazvucni_denzitometar from "./images/devices/ultrazvucni_denzitometar.jpg";
import ultrazvuk from "./images/devices/ultrazvuk.jpg";
import dopler_ultrazvuk from "./images/devices/dopler_ultrazvuk.jpg";
import bera from "./images/devices/bera.jpg";
import kardiotokografija from "./images/devices/kardiotokografija.jpg";
import elektroforeza from "./images/devices/elektroforeza.jpg";
import ekg_holter from "./images/devices/ekg_holter.jpg";
import tecni_azot from "./images/devices/tecni_azot.jpg";
import spirometar from "./images/devices/spirometar.jpg";
import elektroencefalograf from "./images/devices/elektroencefalograf.jpg";
import puls_oksimetar from "./images/devices/puls_oksimetar.jpg";
import kolposkop from "./images/devices/kolposkop.jpg";
import videonistagmograf from "./images/devices/videonistagmograf.jpg";

// import dermoskop from "./images/devices/dermoskop.jpg";


import ruza_sente from "./images/doctors/ruza_sente.jpg";
import marko_sente from "./images/doctors/marko_sente.jpg";
import aleksandar_gakovic from "./images/doctors/aleksandar_gakovic.jpg";
import aleksandar_radulovic from "./images/doctors/aleksandar_radulovic.jpg";
import arpad_loboda from "./images/doctors/arpad_loboda.jpg";
import bogdanka_dapic from "./images/doctors/bogdanka_dapic.jpg";
import branko_miljacki from "./images/doctors/branko_miljacki.jpg";
import ksenija_boskovic from "./images/doctors/ksenija_boskovic.jpg";
import marija_stevic_major from "./images/doctors/marija_stevic_major.jpg";
import natasa_vukadinovic from "./images/doctors/natasa_vukadinovic.jpg";
import tatjana_stojsic from "./images/doctors/tatjana_stojsic.jpg";
import katja_puleva from "./images/doctors/katja_puleva.jpg";

const getImage = name => {
 switch(name) {
   case "ruza_sente":   return ruza_sente;
   case "marko_sente":   return marko_sente;
   case "aleksandar_gakovic":   return aleksandar_gakovic;
   case "aleksandar_radulovic":   return aleksandar_radulovic;
   case "arpad_loboda":   return arpad_loboda;
   case "bogdanka_dapic":   return bogdanka_dapic;
   case "branko_miljacki":   return branko_miljacki;
   case "ksenija_boskovic":   return ksenija_boskovic;
   case "marija_stevic_major":   return marija_stevic_major;
   case "natasa_vukadinovic":   return natasa_vukadinovic;
   case "tatjana_stojsic_vuksanovic":   return tatjana_stojsic;
   case "katja_puleva":   return katja_puleva;

   case "elektrokardiograf":          return elektrokardiograf;
   case "hirurski_laser":             return hirurski_laser;
   case "meki_laser":                 return meki_laser;
   case "otoakusticke_emisije":       return otoakusticke_emisije;
   case "audiometar":                 return audiometar;
   case "timpanometar":               return timpanometar;
   case "ultrazvucni_denzitometar":   return ultrazvucni_denzitometar;
   case "ultrazvuk":                  return ultrazvuk;
   case "dopler_ultrazvuk":           return dopler_ultrazvuk;
   case "bera":                       return bera;
   case "kardiotokografija":          return kardiotokografija;
   case "elektroforeza":              return elektroforeza;
   case "ekg_holter":                 return ekg_holter;
   case "tecni_azot":                 return tecni_azot;
   case "spirometar":                 return spirometar;
   case "elektroencefalograf":        return elektroencefalograf;
   case "puls_oksimetar":             return puls_oksimetar;
   case "kolposkop":                  return kolposkop;
   case "videonistagmograf":          return videonistagmograf;
   default:                           return null;
 }
};

export default getImage;



// WEBPACK FOOTER //
// ./src/imageService.js